module.exports = __webpack_public_path__ + "static/Soleo_Anbindung-344e1d7c9b76220725ec026ab1b78466.jpg";